// utils/formatPostalCode.js
export function formatPostalCode(postalCode) {
  return postalCode.replace(/\s+/g, '');
}

